export default __webpack_public_path__ + "static/media/img_Mazhar.432c11a8.png";